export default [
    {
        "year": 1985,
        "question": "能产生干涉现象的两束光是（ ）",
        "A": "频率相同、振幅相同的两束光",
        "B": "频率相同、位相差恒定的两束光",
        "C": "两只完全相同的灯泡发出的光",
        "D": "同一光源的两个发光部分发出的光",
        "answer": "B"
    },
    {
        "year": 1986,
        "question": "能产生干涉现象的两束光是（ ）",
        "A": "频率相同、振幅相同的两束光",
        "B": "频率相同、位相差恒定的两束光",
        "C": "两只完全相同的灯泡发出的光",
        "D": "同一光源的两个发光部分发出的光",
        "answer": "B"
    },
    {
        "year": 1987,
        "question": "在x轴上有两个点电荷一个带正电Q1,一个带负电-Q2.且Q1=2Q2。用E1和E2分别表示，两个电荷所产生的场强的大小,则在x轴上（ ）",
        "A": "E1=E2之点只有一处该处合场强为0",
        "B": "E1=E2之点共有两处一处合场强为0另一处合场强为2E2",
        "C": "E1=E2之点共有三处其中两处合场强为0，另一处合场强为2E2",
        "D": "E1=E2之点共有三处其中一处合场强为0，另两处合场强为2E2",
        "answer": "B"
    },
    {
        "year": 1988,
        "question": "一个人站在阳台上,以相同的速度v0分别把三个球竖直向上抛出、竖直向下抛出、水平抛 出,不计空气阻力,则三球落地时的速率,（ ）",
        "A": "上抛球最大",
        "B": "下抛球最大",
        "C": "平抛球最大",
        "D": "三球一样大",
        "answer": "D"
    },
    {
        "year": 1989,
        "question": "红色、绿色和黄色的三束平行光分别沿主轴射向同一个玻璃凸透镜,通过透镜后会聚到主轴上，会聚点到光心的距离分别是f红、f绿、f蓝，则（ ）",
        "A": "f红＝f绿＝f蓝",
        "B": "f红＜f蓝＜f绿",
        "C": "f绿＜f蓝＜f红",
        "D": "f红＞f绿＞f蓝 ",
        "answer": "C"
    },
    {
        "year": 1990,
        "question": "第一个发现电磁感应现象的科学家是( )",
        "A": "奥斯特",
        "B": "库仑",
        "C": "法拉第",
        "D": "安培",
        "answer": "C"
    },
    {
        "year": 1991,
        "question": "下列粒子从初速为零的状态经过加速电压为U的电场之后,哪种粒子的速度最大?",
        "A": "质子",
        "B": "氘核",
        "C": "a粒子",
        "D": "钠离子Na+",
        "answer": "A"
    },
    {
        "year": 1992,
        "question": "一定质量的理想气体，在压强不变的条件下，体积增大。则 （ ）",
        "A": "气体分子的平均动能增大",
        "B": "气体分子的平均动能减少",
        "C": "气体分子的平均动能不变",
        "D": "条件不够，无法判定气体分子平均动能的变化",
        "answer": "A"
    },
    {
        "year": 1993,
        "question": "若元素A的半衰期为4天，元素B的半衰期为5天，则相同质量的A和B，经过20天后，剩下的质量之比mA:mB=(   )",
        "A": "30比31",
        "B": "31比30",
        "C": "1比2",
        "D": "2比1",
        "answer": "C"
    },
    {
        "year": 1994,
        "question": "若带正电荷的小球只受到电场力作用，则它在任意一段时间内（ ）",
        "A": "一定沿电力线由高电势处向低电势处运动",
        "B": "一定沿电力线由低电势处向高电势处运动",
        "C": "不一定沿电力线运动，但一定由高电势处向低电势处运动",
        "D": "不一定沿电力线运动，也不一定由高电势处向低电势处运动",
        "answer": "D"
    },
    {
        "year": 1995,
        "question": "两个个物体A和B，质量分别为M和m，用跨过定滑轮的轻绳相连，A静止于水平地面上，如图所示．不计摩擦， A对绳的作用力的大小与地面对A的作用力的大小分别为（ ）",
        "A": "mg，(M－m)g",
        "B": "mg，Mg",
        "C": "(M－m)g，Mg",
        "D": "(M－m)g，(M－m)g",
        "answer": "A"
    },
    {
        "year": 1996,
        "question": "红、橙、黄、绿四种单色光中，光子能量最小的是（ ）",
        "A": "红光",
        "B": "橙光",
        "C": "黄光",
        "D": "绿光",
        "answer": "A"
    },
    {
        "year": 1997,
        "question": "质量为M木块位于粗糙水平桌面上，若用大小为F的水平恒力拉木块，其加速度为a，当拉力方向不变，大小变为2F时，木块的加速度为a′，则（ ）",
        "A": "a′=a",
        "B": "a′＜2a",
        "C": "a′＞2a",
        "D": "a′=2a",
        "answer": "A"
    },
    {
        "year": 1998,
        "question": "处于基态的氢原子在某单色光束照射下，只能发出频率为ν1．ν2．ν3的三种光， 且ν1<ν2<ν3，则该照射光的光子能量为（ ）",
        "A": "hv1",
        "B": "hv2",
        "C": "hv3",
        "D": "h（ν1+ν2+ν3）",
        "answer": "C"
    },
    {
        "year": 1999,
        "question": "一太阳能电池板，测得它的开路电压为800mV，短路电流为40mA．若将该电池板与一阻值为20Ω的电阻器连成一闭合电路，则它的路端电压是（ ）",
        "A": "0.10V",
        "B": "0.20V",
        "C": "0.30V",
        "D": "0.40V",
        "answer": "D"
    },
    {
        "year": 2000,
        "question": "对于一定量的理想气体，下列四个论述中正确的是",
        "A": "当分子热运动变剧烈时，压强必变大",
        "B": "当分子热运动变剧烈时，压强可以不变",
        "C": "当分子间的平均距离变大时，压强必变小",
        "D": "当分子间的平均距离变大时，压强必变大",
        "answer": "B"
    },
    {
        "year": 2001,
        "question": "以下说法正确的是（ ）",
        "A": "纳米材料是指一种称为“纳米”的新物质制成的材料",
        "B": "绿色食品是指不含任何化学物质的食品",
        "C": "生物固氮是指植物通过叶面直接吸收空气中的氮气",
        "D": "光导纤维是以二氧化硅为主要原料制成的",
        "answer": "D"
    },
    {
        "year": 2002,
        "question": "以下说法正确的是（ ）",
        "A": "纳米材料是指一种称为“纳米”的新物质制成的材料",
        "B": "绿色食品是指不含任何化学物质的食品",
        "C": "生物固氮是指植物通过叶面直接吸收空气中的氮气",
        "D": "光导纤维是以二氧化硅为主要原料制成的",
        "answer": "D"
    },
    {
        "year": 2003,
        "question": "一束单色光从空气射入玻璃中，则其（ ）",
        "A": "频率不变，波长变长",
        "B": "频率变大，波长不变",
        "C": "频率不变，波长变短",
        "D": "频率变小，波长不变",
        "answer": "C"
    },
    {
        "year": 2004,
        "question": "一简谐横波在x轴上传播，轴上a、b两点相距12m。t＝0时a点为波峰，b点 为波谷；t＝0.5s时，a点为波谷，b点为波峰。则下列判断中正确的是（ ）",
        "A": "波一定沿x轴正方向传播",
        "B": "波长可能是8m",
        "C": "周期可能是0.5",
        "D": "以上说法均不正确",
        "answer": "B"
    },
    {
        "year": 2005,
        "question": "下列关于热现象的说法，正确的是（ ）",
        "A": "外界对物体做功，物体的内能一定增加",
        "B": "气体的温度升高，气体的压强一定增大",
        "C": "任何条件下，热量都不会由低温物体传递到高温物体",
        "D": "任何热机都不可能使燃料释放的热量完全转化为机械能",
        "answer": "D"
    },
    {
        "year": 2006,
        "question": "下列说法中正确的是（ ）",
        "A": "气体的温度升高时，分子的热运动变得剧烈，分子的平均动能增大，撞击器壁时对器壁的作用力增大，从而气体的压强一定增大",
        "B": "气体体积变小时，单位体积的分子数增多，单位时间内打到器壁单位面积上的分子数增多，从而气体的压强一定增大",
        "C": "压缩一定量的气体，气体的内能一定增加",
        "D": "分子a从远外趋近固定不动的分子b，当a到达受b的作用力为零处时，a的动能一定最大",
        "answer": "D"
    },
    {
        "year": 2007,
        "question": "一束单色光斜射到一厚平板玻璃的一个表面上，经两次折射后从玻璃板另一个表面射出，出射光线相对于入射光线侧移了一段距离，在下列情况下，出射光线侧移距离最大的是（  ）",
        "A": "红光以30°的入射角入射",
        "B": "红光以45°的入射角入射",
        "C": "紫光以30°的入射角入射",
        "D": "紫光以45°的入射角入射",
        "answer": "D"
    },
    {
        "year": 2008,
        "question": "一束单色光斜射到一厚平板玻璃的一个表面上，经两次折射后从玻璃板另一个表面射出，出射光线相对于入射光线侧移了一段距离，在下列情况下，出射光线侧移距离最大的是（  ）",
        "A": "红光以30°的入射角入射",
        "B": "红光以45°的入射角入射",
        "C": "紫光以30°的入射角入射",
        "D": "紫光以45°的入射角入射",
        "answer": "D"
    },
    {
        "year": 2009,
        "question": "下列说法正确的是（  ） ",
        "A": "气体对器壁的压强就是大量气体分子作用在器壁单位面积上的平均作用力",
        "B": "气体对器壁的压强就是大量气体分子单位时间作用在器壁上的平均冲量",
        "C": "气体分子热运动的平均动能减少，气体的压强一定减小",
        "D": "位体积的气体分子数增加，气体的压强一定增大",
        "answer": "A"
    },
    {
        "year": 2010,
        "question": "关于静电场，下列结论普遍成立的是（ ）",
        "A": "场中任意两点之间的电势差只与这两点的场强有关",
        "B": "电场强度大的地方电势高，电场强度小的地方电势低",
        "C": "将正点电荷从场强为零的一点移动到场强为零的另一点，电场力做功为零",
        "D": "在正电荷或负电荷产生的静电场中，场强方向都指向电势降低最快的方向",
        "answer": "D"
    },
    {
        "year": 2011,
        "question": "关于静电场，下列结论普遍成立的是（ ）",
        "A": "场中任意两点之间的电势差只与这两点的场强有关",
        "B": "电场强度大的地方电势高，电场强度小的地方电势低",
        "C": "将正点电荷从场强为零的一点移动到场强为零的另一点，电场力做功为零",
        "D": "在正电荷或负电荷产生的静电场中，场强方向都指向电势降低最快的方向",
        "answer": "D"
    },
    {
        "year": 2012,
        "question": "假设地球和火星都绕太阳做匀速圆周运动，已知地球到太阳的距离小于火星到太阳的距离，那么（ ）",
        "A": "地球公转的线速度小于火星公转的线速度",
        "B": "地球公转的周期大于火星的公转周期",
        "C": "地球公转的角速度大于火星公转的角速度",
        "D": "地球公转的加速度小于火星公转的加速度",
        "answer": "C"
    },
    {
        "year": 2013,
        "question": "假设地球和火星都绕太阳做匀速圆周运动，已知地球到太阳的距离小于火星到太阳的距离，那么（ ）",
        "A": "地球公转的线速度小于火星公转的线速度",
        "B": "地球公转的周期大于火星的公转周期",
        "C": "地球公转的角速度大于火星公转的角速度",
        "D": "地球公转的加速度小于火星公转的加速度",
        "answer": "C"
    },
    {
        "year": 2014,
        "question": "假设地球和火星都绕太阳做匀速圆周运动，已知地球到太阳的距离小于火星到太阳的距离，那么（ ）",
        "A": "地球公转的线速度小于火星公转的线速度",
        "B": "地球公转的周期大于火星的公转周期",
        "C": "地球公转的角速度大于火星公转的角速度",
        "D": "地球公转的加速度小于火星公转的加速度",
        "answer": "C"
    },
    {
        "year": 2015,
        "question": "假设地球和火星都绕太阳做匀速圆周运动，已知地球到太阳的距离小于火星到太阳的距离，那么（ ）",
        "A": "地球公转的线速度小于火星公转的线速度",
        "B": "地球公转的周期大于火星的公转周期",
        "C": "地球公转的角速度大于火星公转的角速度",
        "D": "地球公转的加速度小于火星公转的加速度",
        "answer": "C"
    },
    {
        "year": 2016,
        "question": "平行板电容 器两极板之间充满云母介质，接在恒压直流电源上，若将云母介质移出，则电容器（ ）",
        "A": "极板上的电荷量变大，极板间的电场强度变大",
        "B": "极板上的电荷量变小，极板间的电场强度变大",
        "C": "极板上的电荷量变大，极板间的电场强度不变",
        "D": "极板上的电荷量变小，极板间的电场强度不变",
        "answer": "D"
    },
    {
        "year": 2017,
        "question": "以下关于热运动的说法正确的是( )",
        "A": "水流速度越大，水分子的热运动越剧烈",
        "B": "水凝结成冰后，水分子的热运动停止",
        "C": "水的温度越高，水分子的热运动越剧烈",
        "D": "水的温度升高，每一个水分子的运动速率都会增大",
        "answer": "C"
    },
    {
        "year": 2018,
        "question": "高铁列车在启动阶段的运动可看作初速度为零的均加速直线运动，在启动阶段列车的动能（ ）",
        "A": "与它所经历的时间成正比",
        "B": "与它的位移成正比",
        "C": "与它的速度成正比",
        "D": "与它的动量成正比",
        "answer": "B"
    },
    {
        "year": 2019,
        "question": "楞次定律是下列哪个定律在电磁感应现象中的具体体现（ ）",
        "A": "电阻定律",
        "B": "库仑定律",
        "C": "欧姆定律",
        "D": "能量守恒定律",
        "answer": "D"
    },
    {
        "year": 2020,
        "question": "行驶中的汽车如果发生剧烈碰撞，车内的安全气囊会被弹出并瞬间充满气体。若碰撞后汽车的速度在很短时间内减小为零，关于安全气囊在此过程中的作用，下列说法正确的是（  ）",
        "A": "增加了司机单位面积的受力大小",
        "B": "少了碰撞前后司机动量的变化量",
        "C": "将司机的动能全部转换成汽车的动能",
        "D": "延长了司机的受力时间并增大了司机的受力面积",
        "answer": "D"
    }
]